"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _constants = require("@seedlang/constants");
var _mobx = require("mobx");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _class, _StreakIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  svg {\n    position: absolute;\n    width: ", ";\n    top: ", ";\n    left: 0;\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.top;
});
var InnerWrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Active = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  svg {\n    clipPath: ", ";\n    fill: ", ";\n  }\n"])), function (props) {
  return props.clipPath;
}, function (props) {
  return props.fill;
});
var Inactive = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  svg {\n    fill: #333;\n  }\n"])));
var IconWrapper = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var StreakCount = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  margin-left: 3px;\n  text-align: center;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.fontSize;
});
var StreakIcon = (_class = (_StreakIcon = /*#__PURE__*/function (_React$Component) {
  function StreakIcon() {
    _classCallCheck(this, StreakIcon);
    return _callSuper(this, StreakIcon, arguments);
  }
  _inherits(StreakIcon, _React$Component);
  return _createClass(StreakIcon, [{
    key: "percentageEmpty",
    value: function percentageEmpty() {
      if (this.props.full) {
        return 0;
      } else if (this.props.user) {
        return 100 - this.props.user.currentDayXp / this.props.user.dailyXpGoal * 100;
      } else {
        return 100;
      }
    }
  }, {
    key: "iconColor",
    get: function get() {
      if (this.props.full || this.props.user && this.props.user.currentDayXp >= this.props.user.dailyXpGoal) {
        return _constants.Theme.accentOrange;
      } else {
        return '#dedede';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$user;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width,
        top: this.props.top
      }, /*#__PURE__*/_react["default"].createElement(InnerWrapper, null, /*#__PURE__*/_react["default"].createElement(IconWrapper, {
        width: this.props.width,
        height: this.props.height
      }, this.percentageEmpty() > 0 && /*#__PURE__*/_react["default"].createElement(Inactive, null, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 58 96",
        version: "1.1",
        xmlns: "https://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M55.7,41.3 L38.6,41.3 L54.5,3.1 C55.3,1.1 52.8,-0.6 51.2,0.9 L0.9,51.2 C-0.4,52.5 0.5,54.6 2.3,54.6 L19.4,54.6 L3.5,92.9 C2.7,94.9 5.2,96.6 6.8,95.1 L57.1,44.8 C58.4,43.5 57.5,41.3 55.7,41.3 Z",
        id: "Shape"
      })))), /*#__PURE__*/_react["default"].createElement(Active, {
        fill: this.iconColor
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        className: "active",
        viewBox: "0 0 58 96",
        version: "1.1",
        xmlns: "https://www.w3.org/2000/svg",
        style: {
          clipPath: "polygon(0 ".concat(this.percentageEmpty(), "%, 100% ").concat(this.percentageEmpty(), "%, 100% 100%, 0% 100%)")
        }
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M55.7,41.3 L38.6,41.3 L54.5,3.1 C55.3,1.1 52.8,-0.6 51.2,0.9 L0.9,51.2 C-0.4,52.5 0.5,54.6 2.3,54.6 L19.4,54.6 L3.5,92.9 C2.7,94.9 5.2,96.6 6.8,95.1 L57.1,44.8 C58.4,43.5 57.5,41.3 55.7,41.3 Z",
        id: "Shape"
      }))))), !this.props.hideStreakNumber && /*#__PURE__*/_react["default"].createElement(StreakCount, {
        color: this.props.color,
        fontSize: parseInt((_this$props$user = this.props.user) === null || _this$props$user === void 0 ? void 0 : _this$props$user.currentStreakCount, 10) > 999 ? '9px' : this.props.fontSize
      }, this.props.user && this.props.user.currentStreakCount)));
    }
  }]);
}(_react["default"].Component), _StreakIcon.defaultProps = {
  color: '#000',
  width: '13px',
  height: '22px',
  fontSize: '14px',
  top: 0
}, _StreakIcon), _applyDecoratedDescriptor(_class.prototype, "iconColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "iconColor"), _class.prototype), _class);
var _default = exports["default"] = StreakIcon;